import { EnumLike } from '@/api/types';
import { FLOODING } from '@/consts';

import { faker } from '@faker-js/faker';

export const insuranceClaimFolding = {
  fix_method: 'economic_method',
  settlement: 'no',
  policy_type: 'perpetrator_vehicle_liability',
  any_invoices: 'yes',
  property_type: 'apartment',
  drying_method: 'equipment_rental',
  ownership_type: 'private',
  damage_repaired: 'yes',
  describe_damage: 'Smacznej kawusi',
  insurer_decision: 'positive',
  what_was_repaired: [
    {
      value: 'drying',
      label: 'Osuszanie',
    },
  ],
  how_much_repair_cost: '7000.00',
  how_much_insurer_paid: '2000.00',
  property_ownership_status: 'owner',
  settlement_was_sufficient: 'no',
};

export const insuranceClaimFoldingDD = {
  settlement: 'no',
  policy_type: 'perpetrator_liability',
  ownership_type: 'private',
  property_type: 'apartment',
  damage_repaired: 'no',
  describe_damage: 'Smacznej kawusi',
  insurer_decision: 'positive',
  what_was_repaired: [
    {
      value: 'ozonation',
      label: 'Ozonowanie',
    },
  ],
  deepdry_allow_contact: true,
  how_much_insurer_paid: '30000.00',
  property_ownership_status: 'owner',
};

export const insuranceClaim = {
  property_type: 'apartment',
  damage_repaired: 'no',
  describe_damage: 'Smacznej kawusi',
  how_much_insurer_paid: '7000.00',
  insurer_decision: 'positive',
  ownership_type: 'company',
  vat_payer: 'yes',
  policy_type: 'perpetrator_liability',
  property_ownership_status: 'owner',
  settlement: 'no',
};

export const insuranceClaimFoldingWithoutType = {
  issue_type: '6',
  ...insuranceClaim,
};

export const insuranceClaimFoldingDDWithoutType = {
  issue_type: '1',
  ...insuranceClaimFoldingDD,
};

export const damage_location = {
  city: {
    label: 'Ostrowski > Ostrów Wielkopolski > Ostrów Wielkopolski',
    value: 32719,
  },
  address: {
    label: 'Kazimierza Pułaskiego',
    value: 198537,
  },
  flat_number: faker.number.int(100).toString(),
  zip_code: '63-400',
  building_number: faker.location.buildingNumber(),
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addressHelper = (withAddress: boolean, obj: Record<any, any>) => {
  return withAddress ? { ...obj, damage_location } : obj;
};

const stepsHelper = (
  steps: number,
  innerStep: number,
  withAddress: boolean
  // withDocuments: boolean
) => {
  if (withAddress) {
    return {
      step: steps + 1,
      innerStep: { '0': innerStep, '1': 0 },
    } as { step: number; innerStep: { [p: number]: number } };
  }
  return {
    step: steps,
    innerStep: { '0': innerStep },
  } as { step: number; innerStep: { [p: number]: number } };
};

export const dataHelper = ({
  issueType,
  withAddress,
}: {
  issueType: EnumLike | null;
  withAddress?: boolean;
}) => {
  if (issueType?.value === FLOODING) {
    return {
      form_data: addressHelper(!!withAddress, insuranceClaimFolding),
      stepper: stepsHelper(0, 3, !!withAddress),
    };
  }

  if (issueType === null) {
    return {
      form_data: addressHelper(!!withAddress, insuranceClaimFoldingWithoutType),
      stepper: stepsHelper(0, 4, !!withAddress),
    };
  }

  return {
    form_data: addressHelper(!!withAddress, insuranceClaim),
    stepper: stepsHelper(0, 3, !!withAddress),
  };
};
